<div class="top-bar" *ngIf="state | async; else loading" [@inTopAnimation]>
  <div class="avatar-container">
    <div class="avatar" (click)="goToMain()">
      <img src="assets/images/character.png" alt="">
    </div>
  </div>
  <div class="tries-container" (click)="buyTries()">
    <img src="assets/images/tries.png" alt="">
    <span class="score">{{tries | async  | scoreNumber}}</span>
    <i class="fa fa-plus tries"></i>
  </div>
  <div class="resources-container" (click)="buyResources()">
    <img src="assets/images/resource.png" alt="">
    <span class="score">{{resources | async | scoreNumber}}</span>
    <i class="fa fa-plus resources"></i>
  </div>
  <div class="score-container ">
    <img src="assets/images/score.png" alt="">
    <span class="score">{{score | async | scoreNumber}}</span>
  </div>
</div>
<ng-template #loading></ng-template>
